import Sidebar from './Sidebar';

export default function DashboardLayout({ title, children }) {
  return (
    <div className="flex h-screen overflow-hidden bg-theme-secondary">
      <Sidebar />
      <main className="flex-1 bg-theme-main rounded-tl-2xl m-2 ml-0 p-8 overflow-y-auto">
        {title && <h1 className="text-2xl font-semibold mb-6 text-theme-text">{title}</h1>}
        {children}
      </main>
    </div>
  );
}
